AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Topic");

AoPS.Alcumus.Models.Topic = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;
	var AlcMTrialColl = AoPS.Alcumus.Models.TrialCollection;
	var AlcMProbStats = AoPS.Alcumus.Models.ProblemStats;

	return AlcMBase.BaseModel.extend({
		model_type: "topic",
		id_attribute: "topic_id",
		defaults: {
			name: "",
			description: "",
			status: "notready",
			order: 0,
			progress: 0,
			// Set in constructor to avoid mutability issues
			readings: null, // []
			videos: null, // []
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
			subject: Subject model owning this one
			problem_stats: ProblemStats model with problem totals
			classes: collection of Class models this topic is in
			trials: collection of Trial models that are loaded for this subject
		*/

		initialize: function () {
			this.setLoader(
				new LoadUtils.LoadManager({
					loadHandler: this.loadTopic,
					context: this,
				})
			);

			this.set("readings", []);
			this.set("videos", []);
			this.set("problem_stats", new AlcMProbStats());
			this.set("classes", new AlcMBase.BaseCollection());

			this.set("trials", new AlcMTrialColl());
			// Ensure we always have the same model as in the user's collection.
			this.get("trials").setCreateFunction(
				_.bind(function (id) {
					var result = this.get("user").get("trials").getOrCreate(id);
					result.get("topics").add(this);
					return result;
				}, this)
			);

			this.get("trials").setLoadParams({
				user_id: this.get("user").id,
				topic_id: this.id,
			});
			this.get("trials").watchUser(this.get("user"));
		},

		loadTopic: function (callback) {
			AlcMBase.ajax.run(
				"load_topic",
				{
					user_id: this.get("user").id,
					topic_id: this.id,
				},
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}
					this.unpack(data.response.topic);
					callback(ok, {});
				}, this)
			);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);
			this.get("problem_stats").unpack(data);
		},

		// Converts status code to string to display to user.
		// Argument optional; defaults to model's actual status value.
		formatStatus: function (status) {
			switch (status || this.get("status")) {
				case "ready":
					return "Unpassed";
				case "review":
					return "Review";
				case "passed":
					return "Passed";
				case "mastered":
					return "Mastered";
				default:
					return "";
			}
		},
	});
})();
